import api from './api'

export const emailSettingsService = {
  getSettings: async () => {
    const response = await api.get('/email-settings')
    return response.data
  },

  updateSettings: async (data) => {
    const response = await api.put('/email-settings', data)
    return response.data
  }
}
